<!-- <h2 style="background: yellow;">Este es el total de la lista {{total}}
  <br><b>-------hijo</b>
</h2> -->
<br>
<button (click)="sendMessage()">Dar valor al input</button>
<button (click)="sendSecondAction()">Otro valor</button>
